import c from './index.module.scss'
import {useTranslation} from "react-i18next";
const Footer = () => {
    const { t } = useTranslation();
    return (
        <footer className={c.manticore_footer}>
            <div className={c.footer_inner}>
                <div className={c.inner_link}>
                    <div className={c.link_title}>{t('footer.cooperation')}</div>
                    <a target='_blank' href='mailto:partners@manticore.bot' className={c.link_path}>partners@manticore.bot</a>
                </div>
                <div className={c.inner_link}>
                    <div className={c.link_title}>{t('footer.law')}</div>
                    <a target='_blank' href='mailto:legal@manticore.bot' className={c.link_path}>legal@manticore.bot</a>
                </div>
                <div className={c.inner_link}>
                    <div className={c.link_title}>{t('footer.support')}</div>
                    <a target='_blank' href='mailto:support@manticore.bot' className={c.link_path}>support@manticore.bot</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;